<template>
  <div class="xian-C-1">
    <div class="C-1-row-1"></div>
    <div class="C-1-row-2 flex-row-between">
      <div class="metting-room Boston">
        <div class="boston-inner"></div>
        <!-- <i class="XAzhuzi BostonZhuzi"></i> -->
        会议室（波士顿）
      </div>
      <div class="metting-room bulage">
        <!-- <i class="XAzhuzi BostonZhuzi"></i> -->
        会议室（布拉格）
      </div>
      <div class="kong2"></div>
    </div>
    <div class="flex-row C-1-row-3">

      <div :class="checkList.includes('B') ? 'Bqu' : 'Bqu-hidden'">
        <div class="flex-row-r B15 td3width2 margin-left-2td3" style="width:2rem">
          <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.B15" :key="i.seat">
            <ul>
              <li>姓名：{{ i.name || "" }}</li>
              <li>区域：{{ i.region }}区</li>
              <li>座位：{{ i.seat }}</li>
              <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

            </ul>
            <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
              :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
              {{ i.name ? i.name : "空置" }}
              <!-- {{ i.seat }} -->
            </el-button>
          </el-popover>
        </div>
      </div>

      <div :class="checkList.includes('B') ? 'Bqu' : 'Bqu-hidden'">
        <div class="flex-row-r B8 td3width2 margin-left-2td3">
          <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.B8" :key="i.seat">
            <ul>
              <li>姓名：{{ i.name || "" }}</li>
              <li>区域：{{ i.region }}区</li>
              <li>座位：{{ i.seat }}</li>
              <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

            </ul>
            <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
              :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
              {{ i.name ? i.name : "空置" }}
              <!-- {{ i.seat }} -->
            </el-button>
          </el-popover>
        </div>
      </div>

      <div :class="checkList.includes('B') ? 'Bqu' : 'Bqu-hidden'">
        <div class="flex-row-r B9 td3width2 margin-left-6rem">
          <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.B9" :key="i.seat">
            <ul>
              <li>姓名：{{ i.name || "" }}</li>
              <li>区域：{{ i.region }}区</li>
              <li>座位：{{ i.seat }}</li>
              <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

            </ul>
            <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
              :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
              {{ i.name ? i.name : "空置" }}
              <!-- {{ i.seat }} -->
            </el-button>
          </el-popover>
        </div>
      </div>

      <div :class="checkList.includes('B') ? 'Bqu' : 'Bqu-hidden'">
        <div class="flex-row-r B10 td3width2 margin-left-7rem">
          <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.B10" :key="i.seat"
            :disabled="i.seat.indexOf('null') > -1">
            <ul>
              <li>姓名：{{ i.name || "" }}</li>
              <li>区域：{{ i.region }}区</li>
              <li>座位：{{ i.seat }}</li>
              <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

            </ul>
            <template slot="reference">
              <div v-if="i.seat.indexOf('null') > -1" style="height: 5rem;width: 2rem;"></div>
              <el-button v-else :id="i.name" :class="'common_td3' + ' ' + i.name"
                :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                {{ i.name ? i.name : "空置" }}
                <!-- {{ i.seat }} -->
              </el-button>
            </template>
          </el-popover>
        </div>
      </div>

      <div class="row-3-right margin-left-1td3">

        <div :class="checkList.includes('B') ? 'Bqu' : 'Bqu-hidden'">
          <div class="flex-row B12">
            <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.B12"
              :key="i.seat">
              <ul>
                <li>姓名：{{ i.name || "" }}</li>
                <li>区域：{{ i.region }}区</li>
                <li>座位：{{ i.seat }}</li>
                <li>一级部门：{{ i.oneDepartment }}</li>
                <li>二级部门：{{ i.twoDepartment }}</li>
                <li>三级部门：{{ i.threeDepartment }}</li>

              </ul>
              <el-button :id="i.name" :class="'common_td' + ' ' + i.name" slot="reference"
                :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                {{ i.name ? i.name : "空置" }}
                <!-- {{ i.seat }} -->
              </el-button>
            </el-popover>
          </div>
        </div>

        <div :class="checkList.includes('B') ? 'Bqu' : 'Bqu-hidden'">
          <div class="flex-row B11">
            <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.B11"
              :key="i.seat">
              <ul>
                <li>姓名：{{ i.name || "" }}</li>
                <li>区域：{{ i.region }}区</li>
                <li>座位：{{ i.seat }}</li>
                <li>一级部门：{{ i.oneDepartment }}</li>
                <li>二级部门：{{ i.twoDepartment }}</li>
                <li>三级部门：{{ i.threeDepartment }}</li>

              </ul>
              <el-button :id="i.name" :class="'common_td' + ' ' + i.name" slot="reference"
                :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
                {{ i.name ? i.name : "空置" }}
                <!-- {{ i.seat }} -->
              </el-button>
            </el-popover>
          </div>
        </div>
      </div>

    </div>

    <div class="flex-align-end C-1-row-4">
      <div :class="checkList.includes('B') ? 'Bqu' : 'Bqu-hidden'">
        <div class="flex-row-r XB3 td3width2">
          <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.B3" :key="i.seat">
            <ul>
              <li>姓名：{{ i.name || "" }}</li>
              <li>区域：{{ i.region }}区</li>
              <li>座位：{{ i.seat }}</li>
              <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

            </ul>
            <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
              :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
              {{ i.name ? i.name : "空置" }}
              <!-- {{ i.seat }} -->
            </el-button>
          </el-popover>
        </div>
      </div>

      <div :class="checkList.includes('B') ? 'Bqu' : 'Bqu-hidden'">
        <div class="flex-row XB4 td3width2 margin-left-2td3">
          <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.B4" :key="i.seat">
            <ul>
              <li>姓名：{{ i.name || "" }}</li>
              <li>区域：{{ i.region }}区</li>
              <li>座位：{{ i.seat }}</li>
              <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

            </ul>
            <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
              :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
              {{ i.name ? i.name : "空置" }}
              <!-- {{ i.seat }} -->
            </el-button>
          </el-popover>
        </div>
      </div>

      <div :class="checkList.includes('B') ? 'Bqu' : 'Bqu-hidden'">
        <div class="flex-row-r XB5 td3width2 margin-left-2td3">
          <i class="XAzhuzi B5zhuzi"></i>
          <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.B5" :key="i.seat">
            <ul>
              <li>姓名：{{ i.name || "" }}</li>
              <li>区域：{{ i.region }}区</li>
              <li>座位：{{ i.seat }}</li>
              <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

            </ul>
            <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
              :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
              {{ i.name ? i.name : "空置" }}
              <!-- {{ i.seat }} -->
            </el-button>
          </el-popover>
        </div>
      </div>

      <div :class="checkList.includes('B') ? 'Bqu' : 'Bqu-hidden'">
        <div class="flex-row-r XB6 td3width2 margin-left-2td3">
          <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.B6" :key="i.seat">
            <ul>
              <li>姓名：{{ i.name || "" }}</li>
              <li>区域：{{ i.region }}区</li>
              <li>座位：{{ i.seat }}</li>
              <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

            </ul>
            <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
              :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
              {{ i.name ? i.name : "空置" }}
              <!-- {{ i.seat }} -->
            </el-button>
          </el-popover>
        </div>
      </div>

      <div :class="checkList.includes('B') ? 'Bqu' : 'Bqu-hidden'">
        <div class="flex-row XB7 td3width2 margin-left-2td3">
          <el-popover placement="right" title="信息" width="250" trigger="hover" v-for="i of seatData.B7" :key="i.seat">
            <ul>
              <li>姓名：{{ i.name || "" }}</li>
              <li>区域：{{ i.region }}区</li>
              <li>座位：{{ i.seat }}</li>
              <li>一级部门：{{ i.oneDepartment }}</li>
              <li>二级部门：{{ i.twoDepartment }}</li>
              <li>三级部门：{{ i.threeDepartment }}</li>

            </ul>
            <el-button :id="i.name" :class="'common_td3' + ' ' + i.name" slot="reference"
              :type="i.isUnused === '1' ? 'success' : 'danger'" plain>
              {{ i.name ? i.name : "空置" }}
              <!-- {{ i.seat }} -->
            </el-button>
          </el-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../common.scss'

export default {
  data() {
    return {}
  },
  props: {
    seatData: {
      type: Object,
      default() {
        return {}
      }
    },
    checkList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  watch: {
    checkList(val) { },
    immediate: true
  }
}
</script>
<style lang="scss" scoped>
.xian-C-1 {
  width: 53.5rem;
  border: 1px solid #d9d9d9;
  border-left: none;
  border-bottom: none;
}

.C-1-row-1 {
  display: flex;
  background-color: #d9d9d9;
  height: 28rem;
}

.row-1-left {
  width: 30rem;
  position: relative;

  .C1zhuzi {
    position: absolute;
    right: 0;
  }
}

.row-1-right {
  flex: 1;
  padding-left: 5rem;
}

#Madrid {
  width: 20rem;
  height: 12rem;
  line-height: 12rem;
}

.Boston {
  width: 20rem;
  height: 15rem;
  position: relative;
  margin: 5rem 0 0 0;
  line-height: 14rem;

  .boston-inner{
    position: absolute;
    bottom: -15rem;
    left: -31rem;
    width: 31rem;
    height: 15rem;
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
  }
}

.bulage {
  width: 13rem;
  height: 20rem;
  position: relative;
  margin: 5rem 0 0 0;
  line-height: 16rem;
}

#Prague {
  width: 20rem;
  height: 10rem;
  line-height: 10rem;
  border-top: none;
}

.groceriesRoom {
  height: 6rem;
  line-height: 6rem;
  width: 10rem;
  border: 1px solid #000;
  border-top: none;
  text-align: center;
}

.C-1-row-2 {
  // height: 31rem;
  width: 100%;

  // margin: 0 0rem 4rem;

  .kong2 {
    width: 20rem;
    background-color: #d9d9d9;
  }
}

.C-1-row-3 {
  .row-3-right {
    display: flex;
    flex-direction: column-reverse;
    // justify-content: space-between;
    width: 15rem;
    // margin-left: 1rem;
    .Bqu {
      margin-top: 5rem;
    }
  }
}

.C-1-row-4 {
  width: 100%;
  height: 25rem;
  padding-left: 4rem;
}

.XB5 {
  position: relative;

  .B5zhuzi {
    bottom: 0;
    right: 4rem;
    position: absolute;
  }
}
</style>
